import { render } from "./GuestLayoutComponent.vue?vue&type=template&id=c4a7b7cc"
import script from "./GuestLayoutComponent.vue?vue&type=script&lang=js"
export * from "./GuestLayoutComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__